import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';

if (environment.production) {
    enableProdMode();
}

// TODO: Remove when things are fixed upstream (or in the browser?).
// Workaround for Angular issue: https://github.com/angular/angular/issues/35219
// and underlying Chromium bug:https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
// tslint:disable
(function() {
    const arrayReduce = Array.prototype.reduce;
    let callback;
    Object.defineProperty(Array.prototype, 'reduce', {
        value: function(cb, ...args) {
            callback = cb;
            return arrayReduce.call(this, callback, ...args);
        },
    });
})();

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
